import { Component, inject, OnInit } from '@angular/core';
import { StoreService } from 'src/app/services/store.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { decompress } from 'lz-string';
import { BaseComponent } from '../base-component/base.component';
import { ExcelObject, formatAsDateOptions, UtilService } from 'src/app/services/util.service';
import { utils, writeFile } from 'xlsx';
import { DatePipe } from '@angular/common';
import { LoadingService } from 'src/app/services/loading.service';
import { DeviceInfoService, TABLET_RESOLUTION_CUTOFF } from 'src/app/services/device-info.service';
import { translateDateForSQLServer } from 'src/app/Utility/date_functions/SQL_ISO_adapter';
import { BehaviorSubject, combineLatest, map, startWith } from 'rxjs';
import { VanSalePrintHistory, VisitClient } from 'src/app/Interfaces/SQL-reports-responses';

type RadioValues = 'basic' | 'detailed';

type VanSalePrintHistoryDisplay = Omit<VanSalePrintHistory, 'PDFDate'> & { externalPDFLink: string; PDFDate: Date };

@Component({
	selector: 'app-van-sale-prints',
	templateUrl: './van-sale-prints.component.html',
	styleUrls: ['./van-sale-prints.component.scss'],
})
export class VanSalePrintsComponent extends BaseComponent implements OnInit {
	_util = inject(UtilService);
	_device = inject(DeviceInfoService);
	private _loading = inject(LoadingService);
	private acr = inject(ActivatedRoute);
	private fb = inject(FormBuilder);
	private router = inject(Router);

	constructor() {
		super();
	}

	form = this.fb.group({
		Agent: ['all'],
		// Date: [<string[]>[], Validators.required],
		from: [<Date>null],
		to: [<Date>null],
		Name: ['all'],
	});
	// formValues$ = this.form.valueChanges.pipe(startWith(this.form.value));
	burgerMenu = false;
	burgerMenuNoScroll = false;
	headerAbsolute = false;

	allPrints$ = new BehaviorSubject<VanSalePrintHistoryDisplay[]>([]);

	public Agents;
	public AllClients;
	public AllClientsName;
	public AllClientsSearch;

	agentsToGet = [];

	public Dates: string[] = [];
	public Names = [];
	agents = [];
	dateFilterFunction = (date: Date): boolean => {
		const dates = this.Dates;

		return date ? dates.includes(translateDateForSQLServer(date).toISOString().slice(0, 10)) : false;
	};

	isAdmin = location.pathname.includes('admin');
	hasString = false;
	hasReasonVisitText = false;

	isPopupOpen = false;

	windowWidth = innerWidth;

	// shouldFilterByClient = this.acr.snapshot.queryParams['clientid'];

	radioControl = new FormControl<RadioValues>('basic');

	isTabletAndUpResolution = this._device.windowWidth$.value >= TABLET_RESOLUTION_CUTOFF;

	showFilterPopup = false;

	hasVisitsPictures = false;

	ngOnInit(): void {
		if (localStorage.getItem('UserName') !== null && localStorage.getItem('AgentId') !== null) {
			this._ss.UserNameConnected = localStorage.getItem('UserName');
			this._ss.AgentIdConnected = localStorage.getItem('AgentId');
		} else {
			this.router.navigate(['login']);
			return;
		}

		this._ss.getVanSalePrintHistory().subscribe({
			next: async res => {
				if (typeof res === 'string') {
					alert('לא ניתן להביא ביקורים');
					history.back();
					return;
				}

				const prints = this.addExternalPDFLinkToAllPrints(res.recordset);
				this.allPrints$.next(prints);
			},
			error: () => {
				alert('לא ניתן ליצור קשר עם השרת, נסו שנית מאוחר יותר');
				history.back();
			},
		});
	}

	public BackToAdmin() {
		history.back();
	}

	valuesObject = {
		First: ['Client_Name', 'AgentID', 'ClientID', 'CreateDate', 'CreateDate', 'ResDesc', 'Remark', 'ResonVisitText'],
	} as const;

	translateForSort(value: typeof this.valuesObject[typeof screen][number], screen: keyof typeof this.valuesObject = Object.keys(this.valuesObject)[0] as keyof typeof this.valuesObject): void {
		let i: number, arrayToSort: any[];

		i = this.valuesObject[screen].findIndex(arr => arr === value);

		if (screen === 'First') {
			arrayToSort = this.AllClients;
		}

		if (i === undefined || i === -1) {
			console.log('i should never show');
			return;
		}

		this._util.sortWithIndex(value, i, arrayToSort);
	}

	downloadExcel() {
		const dataObject: ExcelObject = { data: [], filename: '', extension: 'xlsx' };

		const getFormatOptions = (str: 'date' | 'hour'): formatAsDateOptions => ({ isTrueISO: true, onlyTime: str === 'hour' });

		console.log(this.AllClients);

		const longestStringInColumn: any = {};
		const isAdmin = location.pathname.includes('admin');

		dataObject.data = this.AllClients.map(b => {
			const obj: { [key: string]: string | number } = {
				תאריך: this._util.formatAsDate(b.CreateDate, getFormatOptions('date')),
				לקוח: b.Client_Name ?? b.ClientName,
				'סיכום ביקור': b.ResDesc,
			};
			if (isAdmin) {
				obj['סוכן'] = b.AgentID;
			}

			if (this.radioControl.value === 'detailed') {
				obj['קוד לקוח'] = b.ClientID;
				obj['פירוט'] = b.Remark;
				if (!this.hasString) {
					obj['שעה'] = this._util.formatAsDate(b.CreateDate, getFormatOptions('hour'));
				} else {
					obj['כניסה'] = this._util.formatAsDate(b.string.Enter, getFormatOptions('hour'));
					obj['יציאה'] = this._util.formatAsDate(b.string.Exit, getFormatOptions('hour'));
				}

				if (this.hasReasonVisitText) {
					obj['סיבת ביקור'] = b.ResonVisitText;
				}
			}

			for (const entry of Object.entries(obj)) {
				longestStringInColumn[entry[0]] ??= 0;
				longestStringInColumn[entry[0]] = Math.max(String(entry[1]).length, longestStringInColumn[entry[0]], 3);
			}
			return obj;
		});

		dataObject.filename = 'ביקורים';

		const ws = utils.json_to_sheet(dataObject.data);

		ws['!cols'] = Object.values(longestStringInColumn).map((columnWidth: number) => ({ wch: columnWidth }));

		const wb = utils.book_new();
		if (!wb.Workbook) wb.Workbook = {};
		if (!wb.Workbook.Names) wb.Workbook.Views = [{}];
		wb.Workbook.Views[0].RTL = true;
		utils.book_append_sheet(wb, ws, dataObject.filename);
		writeFile(wb, `${dataObject.filename}.${dataObject.extension}`, { bookType: dataObject.extension, sheet: dataObject.filename, compression: true, cellStyles: true });
	}

	resetFilters() {
		this.form.setValue({
			Agent: 'all',
			from: null,
			to: null,
			Name: 'all',
		});
	}

	private addExternalPDFLinkToAllPrints(prints: VanSalePrintHistory[]): VanSalePrintHistoryDisplay[] {
		return prints.map(print => ({ ...print, externalPDFLink: `${this._ss.CustomerInformation?.CustServer}/${print.PDFFile}`, PDFDate: new Date(print.PDFDate) }));
	}
}
